import { writable } from 'svelte/store'

// team
export const positionStore = writable(null)
export const departmentStore = writable(null)

// projects
export const sector = writable(null)
export const fund = writable(null)
export const geography = writable(null)
export const status = writable(null)